import { render, staticRenderFns } from "./AppBottomNavigation.vue?vue&type=template&id=d5791b96&scoped=true&"
import script from "./AppBottomNavigation.vue?vue&type=script&lang=ts&"
export * from "./AppBottomNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./AppBottomNavigation.vue?vue&type=style&index=0&id=d5791b96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5791b96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBottomNavigation,VBtn,VIcon})
